import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import HelpCentersContent from "modules/HelpCenters";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const HelpCentersPage: React.FC = () => {
  setTitle("Help Center");
  return (
    <Auth>
      <Layout>
        <HelpCentersContent />
      </Layout>
    </Auth>
  );
};

export default HelpCentersPage;
